export const mutations = {
    LOADING: 'LOADING',
    SET_USER: 'SET_USER',
    SET_AUTH_TOKEN: 'SET_AUTH_TOKEN',
    SET_VIEW_TYPES: 'SET_VIEW_TYPES',
    SET_CURRENT_DEVICE: 'SET_CURRENT_DEVICE',
    SET_DEVICES: 'SET_DEVICES',
    SET_GROUPS: 'SET_GROUPS',
    SET_DEVICES_FETCHED: 'SET_DEVICES_FETCHED',
    SET_SELECTED_DEVICE_TYPE: 'SET_SELECTED_DEVICE_TYPE',
    SET_ALL_DEVICES: 'SET_ALL_DEVICES',
    SET_SEARCH_NAME: 'SET_SEARCH_NAME',
    SET_USER_SUBSCRIPTIONS: 'SET_USER_SUBSCRIPTIONS',
};

export const actions = {
    LOGIN: 'LOGIN',
    RESET_PASSWORD: 'RESET_PASSWORD',
    SET_NEW_PASSWORD: 'SET_NEW_PASSWORD',
    SIGNUP: 'SIGNUP',
    VERIFY_EMAIL: 'VERIFY_EMAIL',
    CHECK_AUTH_TOKEN: 'CHECK_AUTH_TOKEN',
    LOGOUT: 'LOGOUT',

    LOAD_DEVICE: 'LOAD_DEVICE',
    LOAD_GROUPS: 'LOAD_GROUPS',
    LOAD_DEVICES: 'LOAD_DEVICES',
    UPDATE_DEVICE: 'UPDATE_DEVICE',
    UPDATE_GROUP: 'UPDATE_GROUP',

    UPDATE_USER: 'UPDATE_USER',
    UPDATE_PASSWORD: 'UPDATE_PASSWORD',
    UPDATE_EMAIL: 'UPDATE_EMAIL',
    RESEND_VERIFICATION_EMAIL: 'RESEND_VERIFICATION_EMAIL',

    PAUSE_USER_SUBSCRIPTION: 'PAUSE_USER_SUBSCRIPTION',
    RESUME_USER_SUBSCRIPTION: 'RESUME_USER_SUBSCRIPTION',
    CANCEL_USER_SUBSCRIPTION: 'CANCEL_USER_SUBSCRIPTION',
};
